import { catchError } from '@utils/sentry';
export const SECURE_BROWSER_SOFTWARE_NAME = 'Secure Browser';
export const FLOW_CONFIG_STATUS_DRAFT = 'DRAFT';
export const EP_POLICY_MODE_ENFORCE = 'ENFORCE';
export const EP_POLICY_RULE_ACTION_ALLOW = 'ALLOW';
export const SECURE_BROWSER_LAUNCH_URL = 'https://pages.talview.com/securebrowser/';
export const getSecureBrowserConfigByStepId = (rawConfig, stepId) => {
    if (!rawConfig || !stepId)
        return undefined;
    let parsedConfig = rawConfig;
    if (typeof rawConfig === 'string') {
        try {
            parsedConfig = JSON.parse(rawConfig);
        }
        catch (error) {
            catchError({
                title: 'Proview secure browser config parse failed',
                error: error,
                skipToast: true,
            });
            return undefined;
        }
    }
    if (!parsedConfig || typeof parsedConfig !== 'object')
        return undefined;
    const configMap = parsedConfig;
    const mappedConfig = configMap[stepId];
    if (!mappedConfig || typeof mappedConfig !== 'object')
        return undefined;
    return mappedConfig;
};
export function isRunningInSecureBrowser() {
    if (typeof navigator === 'undefined')
        return false;
    const userAgent = navigator.userAgent || '';
    return userAgent.includes('Proview-SB') || userAgent.includes('TalviewBrowser');
}
export function getSecureBrowserConfigFromFlowDetails(flowDetails) {
    const flowConfig = flowDetails?.flow_configs?.[0];
    if (!flowConfig || flowConfig.status === FLOW_CONFIG_STATUS_DRAFT) {
        return null;
    }
    const epPolicy = flowConfig.ep_policy;
    if (!epPolicy || epPolicy.mode !== EP_POLICY_MODE_ENFORCE) {
        return null;
    }
    const sbRule = epPolicy.policy_rules?.find((rule) => rule.software?.name === SECURE_BROWSER_SOFTWARE_NAME && rule.action === EP_POLICY_RULE_ACTION_ALLOW);
    if (!sbRule) {
        return null;
    }
    return {
        kioskMode: sbRule.kiosk_mode ?? true,
        screenContentProtection: sbRule.content_protection ?? true,
        blockKeyboardShortcuts: true,
        blockVirtualMachine: true,
        blockMultipleScreens: true,
        softwareBlocking: { enabled: false, blockedSoftware: [], allowedSoftware: [] },
        secondaryDisplay: { enabled: false, allowedUrls: [] },
    };
}
